<template>
	<v-col cols="12" md="6" lg="4">
		<v-autocomplete
				v-model="peridoSelected"
				:items="periodosList"
				item-text="curso_periodo"
				item-value="id"
				label="Curso com periodo"
				placeholder="Selecione um curso com periodo"
				return-object
				id="curso_periodo"
				:rules="[rules.required]"
			>
				<template v-slot:item="data">
					<v-list-item-content>
						<v-list-item-title>
							Curso: {{ data.item.curso }}
						</v-list-item-title>
						<v-list-item-subtitle>
							Periodo: {{ data.item.inicio }} - {{ data.item.fim }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</template>
			</v-autocomplete>
	</v-col>
</template>

<script>
import { mapState } from 'vuex'
export default {
	inheritAttrs: false,
	props: {
		periodosList: {
			type: Array,
			default: () => []
		},
		compPeriodoId: {
			default: 0
		},
		compPeriodoIndex: {
			default: 0
		}
	},
	data() {
		return {
			peridoSelected: null,
		}
	},
	computed: {
		...mapState(['rules']),
	},
	watch: {
		peridoSelected: {
			deep: true,
			handler(alert) {
				if(this.peridoSelected!=null){
					this.$emit('peridoSelected', { peridoSelected: +this.peridoSelected.id, compPeriodoId: +this.compPeriodoId })
				}
			}
		}
	},
}
</script>
